import styled from 'styled-components/macro';

export const JustifyContent = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
`;

export const OverflowEllipsis = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ColumnBody = styled.div`
  display: flex;
  padding: ${({ padding }) => padding || '0px'};
  margin: ${({ margin }) => margin || '0px'};
`;

export const HeightCappedList = styled.div`
  max-height: ${({ maxHeight }) => maxHeight || '190px'};
  overflow-y: auto;

  & > div:not(:first-of-type) {
    margin-top: 5px;
  }
`;
